import React, { Fragment, useContext, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import ActionMenu from "../layout/ActionMenu";
import Preloader from "../layout/Preloader";
import DataTable from "../common/DataTable";
import SearchMenu from "../common/SearchMenu";
import Button from "react-bootstrap/Button";
import useTokenCheck from "../../hooks/useTokenCheck";
import ModalDialog from "../../components/common/ModalDialog";
import usePageTitle from "../../hooks/usePageTitle";

const EmployeeManagement = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const { loaded, getConfigValue, getConfigValueByCode } = configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts, setAlertTarget } = alertContext;
  const employeeContext = useContext(EmployeeContext);
  const {
    employees,
    getEmployees,
    employeesLoading,
    loadEmployee,
    removeEmployees,
    clearCurrentEmployee,
    resetEmployeeState,
  } = employeeContext;
  const navigationContext = useContext(NavigationContext);
  const { navigationBack, resetNavigationState } = navigationContext;
  const history = useHistory();
  // let employeeData, pages;
  const [employeeData, setEmployeeData] = useState(null);
  const [pages, setPages] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Employee List",
  });

  const location = useLocation();

  useEffect(() => {
    if (employees) {
      setEmployeeData(employees.data);
      setTableAlert(
        "Search is successfully completed and matching records are displayed in the table"
      );
      setPages({
        numberOfPages: employees.numberOfPages,
        pageNumber: employees.pageNumber,
        numberOfRecords: employees.numberOfRecords,
      });
    }
    //eslint-disable-next-line
  }, [employees]);

  const [searchCriteria, setSearchCriteria] = useState({
    filterType: "all",
    filterValue: "",
  });
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    // const resetEmployeeDetails = async () => {
    console.log("checking navigation", navigationBack);
    if (navigationBack) {
      resetNavigationState();
    } else {
      console.log("RESETing Emp");
      resetEmployeeState();
    }
    // }
    // if (savedCriteria) {
    //   loadPageData(0, searchCriteria);
    // }
    if (loaded) {
      const pageSize = getConfigValue(
        "generalConfig",
        "page_size",
        "App_Config"
      );
      setPageSize(pageSize);
    }
    //eslint-disable-next-line
  }, []);

  //   const { filterType, filterValue } = searchCriteria;

  // const onSearchChange = (e) =>
  //   setSearchCriteria({ ...searchCriteria, filterValue: e.target.value });

  const loadPageData = async (pageNo, criteria) => {
    clearAlerts();
    try {
      if (!criteria) {
        criteria = searchCriteria;
      }
      console.log("###Criteria: ", searchCriteria);
      const res = await getEmployees({ ...criteria, pageNo }, token);
      console.log("$$RES: ", res);
      if (res && res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        setAlert(msg, "warning");
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        setAlert(msg, "warning");
      }
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };
  const getCurrentEmployee = (employee) => {
    console.log("$$$EMPLOYEE filter:", employee);
    const employeeItem = employeeData.filter(
      (item, index) => index === employee
    )[0];
    console.log("$$$EMPLOYEE filtered Item:", employeeItem);
    if (employeeItem) {
      console.log("$$$EMPLOYEE filter ID:", employeeItem.id);
      return employeeItem;
    } else {
      console.log("$$$NULL ID:");
      return null;
    }
  };
  const { hasTokenExpired } = useTokenCheck();
  //setCurrentCard
  const selectCurrentEmployee = async (employee) => {
    await hasTokenExpired();
    clearAlerts();
    try {
      const emp = getCurrentEmployee(employee);
      console.log("Selected EMP:", emp);
      // employeeDispatch({
      //   type: SET_CURRENT_EMPLOYEE,
      //   payload: employeeId,
      // });
      await loadEmployee({ id: emp.id }, token);
      // history.push({
      //   pathname: "/employee-detail",
      //   state: { detail: location.pathname },
      // });
      history.push("/employee-detail", { prevPath: location.pathname });
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const getSelectedIds = (selectedRows) => {
    const selectedEmployees = employeeData.filter(
      (item, index) => selectedRows[index]
    );
    return selectedEmployees.map((item) => item.id);
  };

  const onSearchEmployees = async (criteria) => {
    setTableAlert(" ");
    console.log("###Criteria: ", criteria);
    const { filterType, filterValue } = criteria;
    let searchCriteria = {};

    searchCriteria = {
      filterType: filterType === "" ? "all" : filterType,
    };
    if (filterValue !== "") {
      searchCriteria = {
        ...searchCriteria,
        filterValue,
      };
    }
    setSearchCriteria((prevCriteria) => ({
      ...prevCriteria,
      ...searchCriteria,
    }));
    // setSearchCriteria({ ...searchCriteria });
    // console.log("$$Criteria: ", filterCriteria);
    console.log("$$$Criteria: ", searchCriteria);
    loadPageData(0, searchCriteria);
  };

  const processDeleteResult = async (results) => {
    console.log("###results:", results);
    const successEmployees = results.filter(
      (item) => item.status === "SUCCESS"
    );
    const failedEmployees = results.filter((item) => item.status === "ERROR");
    console.log("###successEmployees:", successEmployees);
    console.log("###failedEmployees:", failedEmployees);
    const successEmployeeNames = successEmployees.map((item) => {
      console.log("###successEmployeeItem:", item);
      console.log("###successEmployeeItem:", item.employeeIds);
      return item.employeeIds;
    });
    const failedEmployeeNames = failedEmployees.map((item) => {
      console.log("###failedEmployeeNamesItem:", item);
      console.log("###failedEmployeeNamesItem:", item.employeeIds);
      return item.employeeIds;
    });
    console.log("###successEmployeeNames:", successEmployeeNames);
    console.log("###failedEmployeeNames:", failedEmployeeNames);
    // console.log("###successEmployees[0].msgCode:", successEmployees[0].msgCode);
    // console.log("###failedEmployees[0].msgCode:", failedEmployees[0].msgCode);
    const successMsgCode =
      successEmployees.length > 0 ? successEmployees[0].msgCode : 0;
    const failureMsgCode =
      failedEmployees.length > 0 ? failedEmployees[0].msgCode : 0;
    let successMsg =
      successMsgCode !== 0
        ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", successMsgCode)
        : "";
    let failureMsg =
      failureMsgCode !== 0
        ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", failureMsgCode)
        : "";
    if (successMsgCode !== 0)
      successMsg = successMsg.replace("{0}", successEmployeeNames);
    if (failureMsgCode !== 0)
      failureMsg = failureMsg.replace("{0}", failedEmployeeNames);
    console.log("###successMsgCode:", successMsgCode);
    console.log("###failureMsgCode:", failureMsgCode);
    console.log("###successMsg:", successMsg);
    console.log("###failureMsg:", failureMsg);
    // const msg = successMsg.concat(successMsg !== "" ? " \n" : "", failureMsg);
    const msg = { successMsg, failureMsg };
    const res = { status: failureMsgCode !== 0, msg };
    console.log("###Res:", res);
    return res;
  };

  const onRemoveEmployee = async () => {
    //Get selected Data Set
    clearAlerts();
    console.log("onRemoveEmployee...", getSelectedIds(selectedRows));
    try {
      const res = await removeEmployees(
        { ids: getSelectedIds(selectedRows) },
        token
      );
      console.log("###Result:", res);
      const rsMsg = await processDeleteResult(res.data);
      console.log("###DelResult:", rsMsg);
      if (rsMsg) {
        console.log("$$$Criteria: ", searchCriteria);
        await loadPageData(0, searchCriteria);
        if (rsMsg.msg?.successMsg !== "")
          setAlertTarget(rsMsg.msg.successMsg, "success", "/emp_mgmt");
        if (rsMsg.status)
          setAlertTarget(rsMsg.msg.failureMsg, "danger", "/emp_mgmt");
      }
    } catch (err) {
      clearAlerts();
      setAlertTarget("Unexpected Error Occured", "danger", "/emp_mgmt");
    }
  };

  const onCreateEmployee = async (e) => {
    await hasTokenExpired();
    //Get changed Data Set
    e.preventDefault();
    clearAlerts();
    clearCurrentEmployee();
    history.push("/create-employee");
  };

  const searchByList = [
    {
      name: "employeeid",
      displayName: "Employee ID",
      requireInput: true,
    },
    {
      name: "lastname",
      displayName: "Last Name",
      requireInput: true,
    },
    {
      name: "firstname",
      displayName: "First Name",
      requireInput: true,
    },
    {
      name: "cardnumber",
      displayName: "Card Number",
      requireInput: true,
    },
    {
      name: "groupname",
      displayName: "Group Name",
      requireInput: true,
    },
  ];

  const columnDefs = [
    {
      Header: "Employee ID",
      accessor: "employeeId",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        console.log(`Clicked for(${rowIndex},${columnId}) :`, value);
        selectCurrentEmployee(rowIndex);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
    },
    {
      Header: "Last Name",
      accessor: "lastName",
    },
    {
      Header: "First Name",
      accessor: "firstName",
    },
    {
      Header: "Card Number",
      accessor: "cardNumber",
    },
    {
      Header: "Group Name",
      accessor: "groupName",
    },
  ];

  const onRemove = (props) => {
    setShowDialog(true);
    setSelectedRows(props);
  };
  const onClose = () => {
    setShowDialog(false);
  };

  const onSubmit = () => {
    setShowDialog(false);
    onRemoveEmployee();
  };

  const [tableAlert, setTableAlert] = useState(" ");
  console.log("setTableAlert", tableAlert);

  return (
    <Fragment>
      {employeesLoading && <Preloader />}
      {showDialog && (
        <ModalDialog
          show={showDialog}
          onClose={onClose}
          onSubmit={onSubmit}
          title={"Confirmation"}
          message={"Are you sure you want to delete?"}
          cancelLabel={"No"}
          submitLabel={"Yes"}
        />
      )}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="patronPage__titleBar">
          <h1 id="pageHeader" className="patronPage__pageTitle">
            EMPLOYEE LIST
          </h1>
          <div id="pageHeader" className="patronPage__pageTitle__action">
            <Button
              variant="primary"
              id="createEmployee"
              aria-label="Create New Employee "
              onClick={onCreateEmployee}
            >
              CREATE NEW EMPLOYEE
            </Button>
          </div>
        </div>
        <div className="patronPage__content">
          <div className="patronPage__searchBar">
            <SearchMenu
              onSearch={onSearchEmployees}
              searchByList={searchByList}
              includePeriod={false}
            />
          </div>
          <div
            aria-live="polite"
            style={{ color: "transparent", height: "1px" }}
          >
            {tableAlert}
          </div>
          {employeeData && employeeData.length > 0 && (
            <div className="patronPage__tableListing">
              <DataTable
                data={employeeData}
                columnDefs={columnDefs}
                pages={pages}
                pageSize={pageSize}
                loadPageData={loadPageData}
                tableAction="REMOVE SELECTED EMPLOYEES"
                onTableAction={onRemove}
                enableRowSelect={true}
              />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default EmployeeManagement;
